module.exports = __webpack_public_path__ + "img/p01.e2b3fbc7.png";